import {
    GET_INVENTORY_NODE,
    GET_ALL_INVENTORY_NODES,
    GET_INVENTORY_NODE_REQUEST,
    CREATE_INVENTORY_NODE,
    UPDATE_INVENTORY_NODE,
    DELETE_INVENTORY_NODE,
    CLEAR_INVENTORY_NODE,
    INVENTORY_NODE_ERROR,
    INVENTORY_NODE_LOADING
} from '../actions/types';

const initialState = {
    inventoryNodes: [],
    inventoryNode: null,
    loading: false,
    error: null
};

export default function inventoryNodeReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case INVENTORY_NODE_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_INVENTORY_NODES:
            return {
                ...state,
                inventoryNodes: payload,
                loading: false,
                error: null
            };

        case GET_INVENTORY_NODE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_INVENTORY_NODE:
            return {
                ...state,
                inventoryNode: payload,
                loading: false,
                error: null
            };

        case CREATE_INVENTORY_NODE:
            return {
                ...state,
                inventoryNodes: [...state.inventoryNodes, payload],
                loading: false,
                error: null
            };

        case UPDATE_INVENTORY_NODE:
            return {
                ...state,
                inventoryNodes: state.inventoryNodes.map(node =>
                    node._id === payload._id ? payload : node
                ),
                inventoryNode: payload,
                loading: false,
                error: null
            };

        case DELETE_INVENTORY_NODE:
            return {
                ...state,
                inventoryNodes: state.inventoryNodes.filter(node => node._id !== payload),
                loading: false,
                error: null
            };

        case CLEAR_INVENTORY_NODE:
            return {
                ...state,
                inventoryNode: null,
                error: null
            };

        case INVENTORY_NODE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };

        default:
            return state;
    }
}
